module.exports = __webpack_public_path__ + "assets/img/live18.66610720.png";